
import { defineComponent, SetupContext } from "vue";
export default defineComponent({
  name: "SeviceTileItem",
  props: {
    /**
     * ラベル
     */
    title: {
      type: String,
      required: true
    },
    /**
     * 画像
     */
    imageUrl: {
      type: String,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    /**
     * タグ押下を通知する
     */
    const onClick = () => {
      context.emit("on-click");
    };

    const onError = (event: Event) =>{
      if (event.target) {
        (event.target as HTMLImageElement).src = require("@/assets/images/noimage1.png"); 
      }
    }

    return {
      onClick,
      onError
    };
  }
});
